import React from 'react';
import { Car, Package, Wrench, ShieldCheck, ArrowUpRight, Sparkles } from 'lucide-react';
import { useContent } from '../context/ContentContext';

const iconMap = { Car, Package, Wrench, ShieldCheck };

const Services = () => {
  const { services } = useContent();
  const [active, setActive] = React.useState(0);

  return (
    <section id="services" className="relative py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <div className="inline-block px-3 py-1 rounded-full bg-sky-100 text-sky-700 text-xs font-semibold tracking-wide uppercase mb-4">
              Our Services
            </div>
            <h2 className="text-3xl md:text-5xl font-bold text-[#0b2f5c] tracking-tight leading-tight">
              Four apps in one. <br />
              <span className="text-sky-500">Zero hassle.</span>
            </h2>
          </div>
          <p className="text-slate-600 md:max-w-sm leading-relaxed">
            Whatever life throws at you, MaLife has a service ready. Explore what we offer across Botswana.
          </p>
        </div>

        <div className="grid lg:grid-cols-4 gap-5">
          {services.map((s, idx) => {
            const Icon = iconMap[s.icon] || Sparkles;
            const isActive = active === idx;
            return (
              <button
                key={s.id || s.title}
                onMouseEnter={() => setActive(idx)}
                onFocus={() => setActive(idx)}
                className={`group text-left relative overflow-hidden rounded-3xl p-7 border transition-all duration-500 ${
                  isActive
                    ? 'bg-gradient-to-br from-[#0b2f5c] to-[#164a8f] border-transparent text-white shadow-2xl shadow-sky-200 lg:scale-[1.02]'
                    : 'bg-slate-50 border-slate-200 hover:border-sky-300 hover:-translate-y-1'
                }`}
              >
                <div
                  className={`w-12 h-12 rounded-2xl flex items-center justify-center mb-6 transition-colors ${
                    isActive ? 'bg-white/15' : 'bg-white shadow-sm'
                  }`}
                >
                  <Icon className={`w-6 h-6 ${isActive ? 'text-sky-200' : 'text-sky-500'}`} strokeWidth={2} />
                </div>

                <div className={`text-xs font-semibold tracking-widest uppercase mb-2 ${
                  isActive ? 'text-sky-200' : 'text-slate-400'
                }`}>
                  {s.tagline}
                </div>
                <h3 className={`text-2xl font-bold mb-3 ${isActive ? 'text-white' : 'text-[#0b2f5c]'}`}>
                  {s.title}
                </h3>
                <p className={`text-sm leading-relaxed mb-6 ${isActive ? 'text-white/80' : 'text-slate-600'}`}>
                  {s.desc}
                </p>

                <div className={`inline-flex items-center gap-1 text-xs font-semibold ${
                  isActive ? 'text-sky-200' : 'text-sky-600'
                }`}>
                  Learn more
                  <ArrowUpRight className="w-3.5 h-3.5 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                </div>

                {isActive && (
                  <div className="absolute -bottom-16 -right-16 w-40 h-40 bg-sky-400/20 rounded-full blur-2xl pointer-events-none" />
                )}
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
